import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { AdvertiseLayout } from '@/components/advertise/AdvertiseLayout';
import { AdvertiseSideSummary } from '@/components/advertise/AdvertiseSideSummary';
import { AdvertiseFooterNav } from '@/components/advertise/AdvertiseFooterNav';
import { ScheduleSlotPicker } from '@/components/advertise/ScheduleSlotPicker';
import { useAdvertise } from '@/store/useAdvertise';
import { useStepGuard, buildersStepValid } from '@/utils/advertiseGuards';
import { BUILDERS_STEPS } from '@/config/advertiseSteps';

export default function BuildersSchedule() {
  const navigate = useNavigate();
  const builders = useAdvertise((s) => s.builders);
  const setField = useAdvertise((s) => s.setField);
  useStepGuard(buildersStepValid.schedule(builders), '/advertise/builders');

  const goNext = () => navigate('/advertise/builders/review');

  return (
    <AdvertiseLayout
      trackLabel="Community Boost"
      steps={BUILDERS_STEPS}
      currentStepId="schedule"
      title="Pick a time for an onboarding call"
      subtitle="20 minutes with our new-construction team — or skip and we'll follow up by email."
      sidebar={<AdvertiseSideSummary items={[{ label: 'Call time', value: builders.slotLabel }]} />}
      footer={
        <AdvertiseFooterNav
          onBack={() => navigate('/advertise/builders/contact')}
          onNext={goNext}
          nextDisabled={!builders.slotIso}
          secondaryAction={
            <Button type="button" variant="ghost" onClick={() => { setField('builders', { slotIso: '', slotLabel: '' }); goNext(); }} className="rounded-xl text-slate-500">
              Skip — email me instead
            </Button>
          }
        />
      }
    >
      <ScheduleSlotPicker
        track="builders"
        value={builders.slotIso ? { iso: builders.slotIso } : null}
        onChange={(slot) => setField('builders', { slotIso: slot.iso, slotLabel: slot.label })}
      />
    </AdvertiseLayout>
  );
}
